module.exports = __webpack_public_path__ + "0e4e19b37721f4191bde39d8a3c46838.fbx";